import angular from 'angular';

export const EmailOptionsDirectiveModule = angular
  .module('acme.common.directive.emailOptions', [])
  .directive('emailOptions', [
    function () {
      return {
        restrict: 'A',
        replace: true,
        templateUrl: 'common/directives/emailOptions/emailOptions.tpl.html',
        scope: {
          flags: '=',
        },

        link: function ($scope, $element, $attrs) {
          // Modified after controller runs
        },

        controller: [
          '$scope',
          function ($scope) {
            $scope.emailOptions = {
              selected: false,

              selectEmailOption: function () {
                if ($scope.flags.noEmail) {
                  this.selected = 0;
                } else if ($scope.flags.sendEmailToAll) {
                  this.selected = 2;
                } else if (!$scope.flags.noEmail && !$scope.flags.sendEmailToAll) {
                  this.selected = 1;
                }
              },

              setEmailOption: function () {
                switch (this.selected) {
                  case 0:
                    $scope.flags.noEmail = true;
                    $scope.flags.sendEmailToAll = false;
                    break;
                  case 1:
                    $scope.flags.noEmail = false;
                    $scope.flags.sendEmailToAll = false;
                    break;
                  case 2:
                    $scope.flags.noEmail = false;
                    $scope.flags.sendEmailToAll = true;
                    break;
                }
              },
            };
          },
        ],
      };
    },
  ]).name;
